import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { promoCodeBannerSerializer } from '@rd/serializers/promo-code-banner.serializer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PromocodeBanner, PromocodeBannerResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class PromocodeBannerApiService {
  constructor(private nydusNetworkDataService: NydusNetworkApiDataService) {}

  getPromocodeBanners(): Observable<PromocodeBanner[]> {
    // TO DO when the api end is ready
    return this.nydusNetworkDataService
      .get<PromocodeBannerResponse>('/promo_code_banners')
      .pipe(
        map((promocodeBannerResponse) => {
          const { data } = promocodeBannerResponse;
          return promoCodeBannerSerializer(data);
        }),
      );
  }
}
